export default "__VITE_ASSET__C_KS4GDl__"